// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"lz","delete_item":"mz","subscription_item":"nz","subscription_item_img_wrapper":"oz","subscription_item_info":"pz","subscription_item_title":"qz","subscription_item_edit":"rz","subscription_item_wrapper":"sz","arrow":"tz","subscription_item_category":"uz","plus_button":"vz","more_details":"wz","old_price":"xz","discount":"yz"};
    if(module.hot) {
      // 1714654886329
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  